import PDFButtonBase from '@/components/PDFButton/Base.vue';
import api from '@/api';

export default {
  mixins: [
    PDFButtonBase,
  ],
  methods: {
    fetchPDF(payload) {
      return api.resource.w2AdHoc(payload);
    },
  },
};
